import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { BAR_CHART_COLORS } from '../../Helpers/ChartConstants.js'
import Highcharts from 'highcharts'
import { formatDateStandard } from '../../../../global/formatters/string-formatter.js'

class OverviewPerformance extends Component {
  constructor(props) {
    super(props)

    this.state = {
      intervals: this.props.performance.performanceIntervals,
      selectedInterval: this.props.performance.performanceValues[0].interval,
    }
  }

  componentDidMount() {
    this.renderBarChart()
  }

  componentDidUpdate() {
    this.renderBarChart()
  }

  handleIntervalChange = (event) => {
    event.preventDefault()
    const value = event.target.value

    this.setState({
      selectedInterval: value,
    })
  }

  getSelectedPerformanceDetails(selectedInterval, performanceDetails) {
    let selectedDetails = null

    if (!selectedInterval || !performanceDetails) {
      return null
    }

    performanceDetails.forEach((detail) => {
      if (detail.interval === selectedInterval) {
        selectedDetails = detail
      }
    })

    return selectedDetails
  }

  renderIntervalDropdown() {
    const { intervals } = this.state

    return intervals.map((option) => {
      const index = intervals.indexOf(option)

      return (
        <option key={option + index} value={option}>
          {option}
        </option>
      )
    })
  }

  renderBarChart() {
    const { performance, fundName } = this.props

    const performanceDetails = this.getSelectedPerformanceDetails(
      this.state.selectedInterval,
      performance.performanceValues
    )
    let seriesData = []
    let chartHeight = 187

    if (performance.displayType === 'NAV') {
      seriesData = [
        {
          name: fundName + ' NAV',
          data: [parseFloat(performanceDetails.navValue)],
        },
      ]

      chartHeight = 120
    } else {
      seriesData = [
        {
          name: fundName + ' NAV',
          data: [parseFloat(performanceDetails.navValue)],
        },
        {
          name: performance.primaryIndex,
          data: [parseFloat(performanceDetails.indexValue)],
        },
      ]
    }

    Highcharts.chart('performance-comparison-chart', {
      chart: {
        height: chartHeight,
        spacingBottom: 15,
        spacingTop: 0,
        style: {
          fontFamily: 'Franklin Gothic Condensed',
          fontSize: '14px',
        },
        type: 'bar',
      },
      colors: BAR_CHART_COLORS,
      credits: { enabled: false },
      legend: {
        align: 'left',
        itemMarginBottom: 5,
        itemStyle: {
          color: 'rgb(35, 31, 32)',
          fontSize: '14px',
          fontWeight: 'normal',
          textOverflow: null,
        },
        navigation: { enabled: false },
        symbolHeight: 12,
        symbolPadding: 4,
        margin: 25,
        padding: 0,
        x: -8,
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: '{y:.2f}%',
            padding: 5,
            style: {
              fontSize: '14px',
              textOutline: 'none',
            },
            verticalAlign: 'middle',
            y: -1,
          },
          groupPadding: 0,
          pointPadding: 0,
          pointWidth: 25,
          states: {
            hover: { brightness: 0 },
          },
        },
      },
      series: seriesData,
      title: { text: '' },
      tooltip: { enabled: false },
      xAxis: {
        visible: false,
        title: {
          text: null,
        },
      },
      yAxis: {
        visible: true,
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        endOnTick: false,
        labels: {
          enabled: false,
        },
        maxPadding: 0.25,
        minPadding: 0.25,
        plotLines: [
          {
            color: '#7b7979',
            dashStyle: 'solid',
            label: {
              rotation: 0,
              style: {
                color: 'rgba(35, 31, 32)',
                fontSize: '12px',
              },
              x: -3,
              y: 12,
              text: '0%',
              textAlign: 'left',
              verticalAlign: 'bottom',
            },
            value: 0,
            width: 2,
            zIndex: 10,
          },
        ],
        title: null,
      },
    })
  }

  render() {
    const { performanceAsOfDate } = this.props.performance

    return (
      <div
        className="u-paddingRight4gu u-sm-paddingRight0 u-sm-paddingBottom3gu"
        id="performance-comparison"
      >
        <div className="Grid Grid--alignMiddle u-flexJustifyBetween">
          <div className="Content u-paddingVert0 u-sizeFit u-sm-sizeFull">
            <h3 className="u-marginTop0 u-marginBottom3gu">
              Performance{' '}
              <span className="u-block u-paddingTop1gu">
                as of {formatDateStandard(performanceAsOfDate)}
              </span>
            </h3>
          </div>
          <div className="u-sizeFit">
            <div className="Dropdown u-marginBottom3gu">
              <select
                defaultValue={this.state.selectedInterval}
                className="Dropdown-menu"
                id="performance-comparison-dropdown"
                onChange={this.handleIntervalChange}
              >
                {this.renderIntervalDropdown()}
              </select>
            </div>
          </div>
        </div>
        <div
          id="performance-comparison-chart"
          className="u-marginBottom1gu"
        ></div>
        <a className="js-subnav-link Link u-textSecondary" href="#performance">
          View more
        </a>
      </div>
    )
  }
}

OverviewPerformance.propTypes = {
  performance: PropTypes.object.isRequired,
  fundName: PropTypes.string,
}

export default OverviewPerformance
